import {get} from '@/api/clients';
import {MapService} from '@/models/dto/map/map-service';

const MAP_SERVICE_API_BASE = '/mapServices';

/**
 * (GET) 지도서버 조회
 * @returns MapServiceDTO 배열
 * @author mark
 */
export const fetchMapServices = async (): Promise<MapService[]> => {
  return await get<MapService[]>(MAP_SERVICE_API_BASE);
};

/**
 * (GET) 지도서버 조회 - 항공사진전용
 * @returns MapServiceDTO 배열
 * @author mark
 */
export const fetchAerialMapServices = async (): Promise<MapService[]> => {
  return await get<MapService[]>(`${MAP_SERVICE_API_BASE}/aerial`);
};
